import {
    deleteFuelRobItem,
    getAllFuelRobItems,
    deleteBunkeringItem,
    getAllBunkeringItems,
    deleteBunkeringStatusItem,
    getAllBunkeringStatusItems,
    deleteBunkerLossItem,
    getAllBunkerLossItems,
} from 'src/api/bunkering/offlineBunkeringApi';
import useSyncHelper from './useSyncHelper';
import { useSWService } from 'src/api/sw/useSWService';

const useSyncOfflineBunkering = () => {
    const { syncItems } = useSyncHelper();
    const { refreshRequestsContaining } = useSWService();

    const syncFuelRobItems = () => syncItems(getAllFuelRobItems, deleteFuelRobItem, ['upsertFuelRobDataRequest'], 'aolDate');
    const syncBunkeringItems = () =>
        syncItems(getAllBunkeringItems, deleteBunkeringItem, ['upsertBunkeringRequest', 'upsertDebunkeringRequest'], 'bunkeringGuid');
    const syncBunkeringStatusItems = () =>
        syncItems(
            getAllBunkeringStatusItems,
            deleteBunkeringStatusItem,
            ['upsertBunkeringStatusRequest', 'deleteBunkeringStatusRequest'],
            'bunkeringStatusGuid'
        );
    const syncBunkerLossItems = () => syncItems(getAllBunkerLossItems, deleteBunkerLossItem, ['upsertBunkerLossDataRequest'], 'bunkerLossKey');

    const syncBunkerings = async (skipRefresh?: boolean | null) => {
        await syncFuelRobItems();
        await syncBunkeringItems();
        await syncBunkeringStatusItems();
        await syncBunkerLossItems();

        if (!skipRefresh) {
            await refreshRequestsContaining(['GetBunkerings', 'GetFuelRobData', 'GetBunkerLossData']);
        }
    };

    return {
        syncBunkerings,
    };
};

export default useSyncOfflineBunkering;
